export const StageStatus = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED: 'COMPLETED',
  CURRENT: 'CURRENT',
};

export const StageId = {
  start: 'start',
  requirements: 'requirements',
  contactInfo: 'contactInfo',
  finish: 'finish',
};

export const getCurrentStageIndex = function (
  stages,
  currentPage,
  isFinalPageBeforeSubmission = false
) {
  if (!stages || stages.length === 0) {
    return 0;
  }

  // Special case: if isFinalPageBeforeSubmission, return finish stage index
  if (isFinalPageBeforeSubmission) {
    return stages.length - 1;
  }

  let currentStageIndex = -1;

  currentStageIndex = stages.findIndex((stage) => {
    if (!stage.pages?.length) return false;
    if (stage.pages.includes(currentPage)) return true;
    if (currentPage < stage.pages[0]) return true;
    return false;
  });

  if (
    currentStageIndex === -1 &&
    stages[stages.length - 1].pages &&
    stages[stages.length - 1].pages.length > 0
  ) {
    currentStageIndex = stages.length - 1;
  }

  // Fallback to start stage if still not found
  if (currentStageIndex === -1) {
    currentStageIndex = 0;
  }

  return currentStageIndex;
};

export const checkStageStatus = function (
  stage,
  stageIndex,
  currentStageIndex,
  isFinalPageBeforeSubmission
) {
  const { id: stageId } = stage;

  if (isFinalPageBeforeSubmission) {
    if (stageId === StageId.finish) {
      return StageStatus.CURRENT;
    }
    // All preceding stages should be set to COMPLETED (not CURRENT)
    return StageStatus.COMPLETED;
  }

  if (currentStageIndex < stageIndex) {
    return StageStatus.INCOMPLETE;
  }

  if (currentStageIndex === stageIndex) {
    return StageStatus.CURRENT;
  }

  return StageStatus.COMPLETED;
};

export const buildStages = (
  postcodePageNumber,
  finishPageNumber,
  pageNumbers
) => {
  const startPageNumber = 0;

  const finishPageNumberWithLastPageFallback =
    finishPageNumber || Math.max(...pageNumbers);

  const requirementsPageNumbers = pageNumbers.filter(
    (pageNumber) =>
      pageNumber !== startPageNumber &&
      pageNumber < (postcodePageNumber || finishPageNumberWithLastPageFallback)
  );

  const contactInfoPageNumbers = postcodePageNumber
    ? pageNumbers.filter(
        (pageNumber) =>
          pageNumber >= postcodePageNumber &&
          pageNumber < finishPageNumberWithLastPageFallback
      )
    : [];

  return [
    {
      id: StageId.start,
      label: 'Get Started',
      pages: [startPageNumber],
    },
    {
      id: StageId.requirements,
      label: 'Your Requirements',
      pages: requirementsPageNumbers,
    },
    {
      id: StageId.contactInfo,
      label: 'Your Contact Info',
      pages: contactInfoPageNumbers,
    },
    {
      id: StageId.finish,
      label: 'Finish',
      pages: [finishPageNumberWithLastPageFallback],
    },
  ];
};
